import React from 'react';
import { GoogleMap, GoogleMapAreaMarker, GoogleMapPinMarker } from 'src/shared/design-system/GoogleMap';

interface IProps {
  className?: string;
  latitude: number;
  longitude: number;
  isApproximateLocation?: boolean;
}

export const ConsumerOrderGoogleMap: React.FC<IProps> = ({
  className,
  isApproximateLocation = false,
  latitude,
  longitude,
}) => {
  let additionalProps = {};

  // Zoom out a little further so that the area marker isn't so close.
  if (isApproximateLocation) {
    additionalProps = {
      defaultZoom: 15,
      maxZoom: 15,
    };
  }

  return (
    <GoogleMap className={className} latitude={latitude} longitude={longitude} {...additionalProps}>
      {isApproximateLocation ? <GoogleMapAreaMarker /> : <GoogleMapPinMarker />}
    </GoogleMap>
  );
};
